import { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import ClassetDropdown from '../../../../../classetComponents/classetDropDown';
import ClassetInputText from '../../../../../classetComponents/classetInputText';
import ClassetCalendar from '../../../../../classetComponents/classetCalender';
import { AdmissionCategoryChangeUtils } from '../utils';
import moment from 'moment';

class NewFeeInfoDialog extends Component {
    renderHeader = () => {
        const { onBackClick } = this.props;
        
        return (
            <div className='flex align-items-center text-center text-black-alpha-80'>
                <span 
                    className="back-arrow-icon"
                    onClick={onBackClick}
                    style={{ cursor: 'pointer' }}
                >
                    <i className="pi pi-arrow-left" style={{ fontSize: '1.5rem', color: '#333' }}></i>
                </span>
                <h3 style={{ margin: 0, flex: 1 }}>New Fee Types</h3>
            </div>
        );
    };

    renderFooter = () => {
        const { onNext, onCancel } = this.props;
        
        return (
            <div className="flex flex justify-content-center my-3">
                <Button
                    className="formAddButton px-4 mr-2"
                    style={{ backgroundColor: '#007bff', color: '#fff', borderRadius: '10px' }}
                    onClick={onNext}
                >
                    <p className="formAddButtonText">Next</p>
                </Button>
                <Button 
                    className="cancelButtonn" 
                    style={{ width: "164px", height: "48px" }} 
                    onClick={onCancel}
                >
                    <p className="cancelButtonnText">Cancel</p>
                </Button>
            </div>
        );
    };

    renderFeeScheduleSelector = () => {
        const { 
            isFromFeeScheduleSelection, 
            newFeeResponse, 
            relatedFeeSchedules, 
            selectedFeeSchedule,
            onFeeScheduleChange 
        } = this.props;

        if (!(isFromFeeScheduleSelection || !newFeeResponse?.feeStructureDetails?.length)) {
            return null;
        }

        return (
            <div className="p-4">
                <div className="mb-4">
                    <ClassetDropdown
                        label="Related Fee Schedules"
                        placeholder="Select Fee Schedule"
                        options={relatedFeeSchedules}
                        value={selectedFeeSchedule}
                        onChange={onFeeScheduleChange}
                        optionLabel="scheduleName"
                        optionValue="_id"
                    />
                </div>
            </div>
        );
    };

    // Helper function to get unique fee types with highest totalFee from selectedFeeStructure array
    getUniqueFeeTypes = (selectedFeeStructure) => {
        if (!Array.isArray(selectedFeeStructure)) {
            return [];
        }

        const allFeeTypes = selectedFeeStructure.reduce((acc, category) => {
            if (Array.isArray(category?.feeTypes)) {
                acc.push(...category.feeTypes);
            }
            return acc;
        }, []);

        // Create a map to store unique fee types with highest totalFee
            const feeTypeMap = new Map();
        allFeeTypes.forEach(feeType => {
            if (!feeType?._id) return;
            
            const existingFeeType = feeTypeMap.get(feeType._id);
            if (!existingFeeType || (feeType.totalFee || 0) > (existingFeeType.totalFee || 0)) {
                feeTypeMap.set(feeType._id, feeType);
            }
        });

        return Array.from(feeTypeMap.values());
    };

    renderFeeTypeSummary = () => {
        const { 
            selectedFeeStructure, 
            isAddEnabled, 
            onAddClick,
            onTotalFeeChange,
            installmentData
        } = this.props;

        // Get unique fee types from the array structure
        const uniqueFeeTypes = this.getUniqueFeeTypes(selectedFeeStructure);

        if (uniqueFeeTypes.length === 0) {
            return null;
        }

        const installmentFeeTypes = uniqueFeeTypes.filter(fee => fee && !fee.isOneTime);

        if (installmentFeeTypes.length === 0) {
            return null;
        }

        return (
            <div className="mb-4 p-3" style={{ borderRadius: '8px' }}>
                <h4 className="mb-3">Add Fee Amount</h4>
                <div className="flex flex-wrap gap-3">
                    {installmentFeeTypes.map((feeType, feeTypeIndex) => {
                        if (!feeType) return null;
                        
                        const enteredAmount = AdmissionCategoryChangeUtils.calculateTotalEnteredAmount(feeType, installmentData);
                        const amountColor = AdmissionCategoryChangeUtils.getAmountColor(enteredAmount, feeType.totalFee || 0);
                        
                        return (
                            <div
                                key={feeType.feeTypeId}
                                className="flex align-items-center p-3"
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '6px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    minWidth: '200px'
                                }}
                            >
                                <div className="flex-column">
                                    <div className="font-semibold mb-2">
                                        {feeType.feeType}
                                    </div>
                                    {!isAddEnabled ? (
                                        <div className="flex align-items-center gap-2">
                                            <ClassetInputText
                                                className='border-round-md no-border custom-field-focused border-none pl-3 body-medium'
                                                height="48px"
                                                width='150px'
                                                value={feeType.totalFee || 0}
                                                keyfilter={"int"}
                                                onChange={e => {
                                                    let val = e.target.value;
                                                    if (/^0\d+/.test(val)) {
                                                        val = val.replace(/^0+/, '');
                                                    }
                                                    onTotalFeeChange(e.target.value, feeTypeIndex, feeType._id);
                                                }}
                                                disabled={feeType.isTransportFeeType}
                                            />
                                        </div>
                                    ) : (
                                        <div className="flex align-items-center gap-2">
                                            <span style={{ color: amountColor }}>
                                                ₹{enteredAmount}
                                            </span>
                                            <span>/</span>
                                            <span style={{ color: '#4CAF50' }}>
                                                ₹{feeType.totalFee || 0}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="flex justify-content-end mt-1">
                    {!isAddEnabled && (
                        <Button
                            className="formAddButton px-4 mr-2"
                            style={{ backgroundColor: '#007bff', color: '#fff', borderRadius: '10px' }}
                            onClick={onAddClick}
                        >
                            <p className="formAddButtonText">Add</p>
                        </Button>
                    )}
                </div>
            </div>
        );
    };

    renderOneTimeFees = () => {
        const { oneTimeFees, isShowInstallmentInfo, onOneTimeFeeChange, onOneTimeDueDateChange } = this.props;

        if (!oneTimeFees?.length || !isShowInstallmentInfo) {
            return null;
        }

        return (
            <div className="mb-4">
                <h4 className="text-xl font-semibold mb-2">One Time Fees</h4>
                <DataTable value={oneTimeFees} responsiveLayout="scroll">
                    <Column field="feeType" header="Fee Type" />
                    <Column
                        header="Total Fee"
                        body={(rowData) => (
                            <ClassetInputText
                                className="border-round-md no-border custom-field-focused border-none pl-3 body-medium"
                                height="48px"
                                width="150px"
                                value={rowData.totalFee || 0}
                                keyfilter="int"
                                onChange={(e) => onOneTimeFeeChange(e.target.value, rowData)}
                                placeholder="Enter amount"
                            />
                        )}
                    />
                    <Column
                        header="Due Date"
                        body={(rowData) => (
                            <ClassetCalendar
                                className="border-calendar"
                                width={'280px'}
                                height={'48px'}
                                inputClassName="font-semibold"
                                calendarMode={'single'}
                                value={AdmissionCategoryChangeUtils.getValidDate(rowData.dueDate)}
                                onChange={(e) => onOneTimeDueDateChange(e.value, rowData)}
                                placeholder="Select Due Date"
                                yearRange="2000:2050"
                            />
                        )}
                    />
                </DataTable>
            </div>
        );
    };

    renderInstallmentData = () => {
        const { 
            isShowInstallmentInfo, 
            isAddEnabled, 
            installmentData, 
            selectedFeePlan,
            onPercentageChange,
            onCalculatedFeeChange
        } = this.props;

        if (!isShowInstallmentInfo || !isAddEnabled || !installmentData?.length) {
            return null;
        }

        return installmentData.map((installment, installmentIndex) => {
            const planInstallment = selectedFeePlan?.installments?.find(
                i => i.installmentId === installment.installmentId
            );

            return (
                <div key={installmentIndex} className="mb-4">
                    <div className="flex align-items-center gap-3 mb-2">
                        <h4 className="m-0">
                            {installment.installment} - {planInstallment ? moment(planInstallment.date).format('DD/MM/YYYY') : 'Date not set'}
                        </h4>
                    </div>
                    <DataTable value={installment.feeTypes} responsiveLayout="scroll">
                        <Column field="feeType" header="Fee Type" />
                        <Column field="totalFee" header="Total Fee" />
                        <Column
                            header="Percentage"
                            body={(rowData) => (
                                <ClassetInputText
                                    value={rowData.percentage || 0}
                                    onChange={(e) => onPercentageChange(e, installmentIndex, rowData)}
                                    placeholder="Percentage"
                                    keyfilter="num"
                                    min={0}
                                    max={100}
                                    className="p-inputtext-sm"
                                    style={{ width: '100px' }}
                                />
                            )}
                        />
                        <Column
                            header="Calculated Fee"
                            body={(rowData) => (
                                <ClassetInputText
                                    value={rowData.calculatedFee || 0}
                                    onChange={(e) => onCalculatedFeeChange(e, installmentIndex, rowData)}
                                    placeholder="Calculated Fee"
                                    disabled={rowData?.isTransportFeeType}
                                    keyfilter="num"
                                    min={0}
                                    max={rowData.totalFee}
                                    className="p-inputtext-sm"
                                    style={{ width: '100px' }}
                                />
                            )}
                        />
                    </DataTable>
                </div>
            );
        });
    };

    render() {
        const { visible, onHide } = this.props;

        return (
            <Dialog
                header={this.renderHeader()}
                draggable={false}
                closable={true}
                visible={visible}
                style={{ width: '80%', height: "80%" }}
                onHide={onHide}
                footer={this.renderFooter()}
                modal
            >
                <div className="mt-2">
                    {this.renderFeeScheduleSelector()}
                    {this.renderFeeTypeSummary()}
                    {this.renderOneTimeFees()}
                    {this.renderInstallmentData()}
                </div>
            </Dialog>
        );
    }
}

export default NewFeeInfoDialog;
